import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterFaqItem } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterFaqItem>();

export class CallCenterFaqItemFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterFaqItem>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterFaqItem)(filters);
  });
}
